import { Box, Button, Chip } from '@mui/material';
import DrawerPanel from '../drawerPanel';
import { useState } from 'react';
import ContactUsForm from './contactUsForm';

type Props = {
  label: string;
};
const ContactUsButton = ({ label }: Props) => {
  const [showForm, setShowForm] = useState(false);

  const hideForm = () => {
    setShowForm(false);
  };

  return (
    <Box>
      <Chip label={label} variant="outlined" color="primary" onClick={() => setShowForm(true)} size="small" />
      <DrawerPanel open={showForm} onClose={hideForm} minWidth={'40vw'}>
        <ContactUsForm onClose={() => setShowForm(false)} />
      </DrawerPanel>
    </Box>
  );
};

export default ContactUsButton;
